import ReservierungVorbestellungLogic from "@/logic/bestellung/reservierung_vorbestellung_logic"

class NeuReservierungVorbestellung {
  public PRODUKTE = "bestellung-neu-reservierung-vorbestellung-produkte2"
  public ARTIKEL = "bestellung-neu-reservierung-vorbestellung-artikel2"
  public BESTAETIGEN = "bestellung-neu-reservierung-vorbestellung-bestaetigen2"
}

class NeuShopping {
  public PRODUKTE = "bestellung-neu-shopping-produkte"
  public ARTIKEL = "bestellung-neu-shopping-artikel"
}

class NeuShoppingLieferung {
  public PRODUKTE = "bestellung-neu-shopping-lieferung-produkte"
  public ARTIKEL = "bestellung-neu-shopping-lieferung-artikel"
}

class Neu {
  public HOME = "home"
  public FILIALE = "filiale-select"
  public TISCH_QR_BUCHEN = "bestellung-neu-tisch-qr-buchen"
  public TERMIN_LIEFERUNG = "bestellung-neu-termin-lieferung"
  public TERMIN_ABHOLUNG = "bestellung-neu-termin-abholung"
  public TERMIN_RESERVIERUNG = "bestellung-neu-termin-reservierung"
  public STANDORT_LIEFERUNG = "bestellung-neu-standort-lieferung"
  public STANDORT_LIEFERUNG_PLZ = "bestellung-neu-standort-lieferung-plz"
  public SOFORTBESTELLUNG_TISCH = "bestellung-neu-sofortbestellung-tisch"
  public SOFORTBESTELLUNG_BESTELLART =
    "bestellung-neu-sofortbestellung-bestellart"
  public SHOPPING_LIEFERUNG = new NeuShoppingLieferung()
  public SHOPPING = new NeuShopping()
  public KUNDENDATEN = "bestellung-neu-kundendaten"
  public KUNDENDATEN_RESERVIERUNG = "bestellung-neu-kundendaten-reservierung"
  public KUNDENDATEN_LIEFERUNG = "bestellung-neu-kundendaten-lieferung"
  public RESERVIERUNG_SELECT_VORBESTELLUNG = "reservierung-select-vorbestellung"
  public RESERVIETUNG_VORBESTELLUNG = new NeuReservierungVorbestellung()
  public BESTAETIGEN = "bestellung-neu-bestaetigen"
  public BESTAETIGEN_RESERVIERUNG = "bestellung-neu-bestaetigen-reservierung"
  public BESTAETIGEN_ABHOLUNG = "bestellung-neu-bestaetigen-abholung"
  public BESTAETIGEN_LIEFERUNG = "bestellung-neu-bestaetigen-lieferung"
  public RESERVIERUNG_BESTAETIGT = "bestellung-neu-reservierung-bestaetigt"
  public BESTAETIGT = "bestellung-neu-bestaetigt"
  public WARENKORB = "bestellung-neu-warenkorb"
  public WARENKORB_LIEFERUNG = "bestellung-neu-warenkorb-lieferung"
  public BEZAHLUNG_BESTAETIGEN = "bestellung-neu-bezahlung-bestaetigen"
  public BEZAHLUNG_WEITERLEITEN = "bestellung-neu-bezahlung-weiterleiten"
  public VERZEHRART = "bestellung-neu-verzehrart"
  public TRINKGELD = "bestellung-neu-trinkgeld"
  public AGB = "bestellung-neu-agb"
  public INFO_PAGE = "bestellung-neu-info-page"
}

class BestellungReservierungBestellung {
  public PRODUKTE = "bestellung-reservierung-bestellung-produkte"
  public ARTIKEL = "bestellung-reservierung-bestellung-artikel"
  public BESTAETIGEN = "bestellung-reservierung-bestellung-bestaetigen"
}

class BestellungNachbestellen {
  public PRODUKTE = "bestellung-nachbestellen-produkte"
  public ARTIKEL = "bestellung-nachbestellen-artikel"
  public BESTAETIGEN = "bestellung-nachbestellen-bestaetigen"
}

class BestellungVorbestellung {
  public PRODUKTE = "bestellung-vorbestellung-produkte"
  public ARTIKEL = "bestellung-vorbestellung-artikel"
  public BESTAETIGEN = "bestellung-vorbestellung-bestaetigen"
}

class Bestellung {
  public DETAILS = "bestellung-details"
  public RESERVIERUNG_BESTELLUNG = new BestellungReservierungBestellung()
  public SERVICE_ANFORDERN = "bestellung-service-anfordern"
  public BEZAHLEN = "bestellung-bezahlen"
  public BEZAHLEN_BESTAETIGT = "bestellung-bezahlen-bestaetigt"
  public NACHBESTELLEN = new BestellungNachbestellen()
  public VORBESTELLUNG = new BestellungVorbestellung()
  public PASSWORT_AENDERN = "passwort-aendern-kunde"
  public FILIALE_INFO = "filiale-info"
}

class BestellungPage {
  public DETAILS = "bestellung-page-details"
  public SERVICE_ANFORDERN = "bestellung-page-service-anfordern"
  public RESERVIERUNG = new BestellungPageReservierung()
  public NACHBESTELLEN = new BestellungPageNachbestellen()
  public VORBESTELLUNG = new BestellungPageVorbestellen()
  public BEZAHLEN = "bestellung-page-bezahlen"
  public TRINKGELD = "bestellung-trinkgeld"
  public BEZAHLUNG_WEITERLEITEN = "bezahlung-weiterleiten"
}

class BestellungPageReservierung {
  public PRODUKTE = "bestellung-page-reservierung-produkte"
  public ARTIKEL = "bestellung-page-reservierung-artikel"
  public BESTAETIGEN = "bestellung-page-reservierung-bestaetigen"
}

class BestellungPageNachbestellen {
  public PRODUKTE = "bestellung-page-nachbestellen-produkte"
  public ARTIKEL = "bestellung-page-nachbestellen-artikel"
  public BESTAETIGEN = "bestellung-page-nachbestellen-bestaetigen"
}

class BestellungPageVorbestellen {
  public PRODUKTE = "bestellung-page-vorbestellen-produkte"
  public ARTIKEL = "bestellung-page-vorbestellen-artikel"
  public BESTAETIGEN = "bestellung-page-vorbestellen-bestaetigen"
}

class ReservierungVorbestellung {
  public PRODUKTE = "reservierung-vorbestellung-produkte3"
  public BEARBEITEN = "reservierung-vorbestellung-bearbeiten3"
}

class Reservierung {
  public DETAILS = "reservierung-details"
  public VORBESTELLUNG_PRODUKTE = "reservierung-vorbestellung-produkte"
  public VORBESTELLUNG_BESTAETIGEN = "reservierung-vorbestellung-bestaetigen"
}

export default class RouteNames {
  public static NEU = new Neu()
  public static BESTELLUNGEN = "bestellungen"
  public static ABGESCHLOSSENE_BESTELLUNGEN = "abgeschlossene_bestellungen"
  public static REGISTRIEREN = "registrieren"
  public static BETRIEB_ANFRAGEN = "betrieb-anfragen"
  public static BESTELLUNG = new Bestellung()
  public static RESERVIERUNG = new Reservierung()
  public static BESTELLUNG_PAGE = new BestellungPage()
  public static RESERVIERUNG_DETAILS = "reservierung-details"
  public static RESERVIERUNG_VORBESTELLUNG = new ReservierungVorbestellung()
  public static PASSWORT_VERGESSEN = "passwort-vergessen"
  public static PASSWORT_AENDERN = "passwort-aendern"
  public static LOGIN_MITARBEITER = "login-mitarbeiter"
  public static LOGIN_SYSTEM = "login-system"
  public static DATENSCHUTZ = "datenschutz"
  public static IMPRESSUM = "impressum"
  public static AGB = "agb"
  public static AGB_RESTAURANTS = "agb-restaurants"
  public static MEIN_ACCOUNT = "mein-account"
  public static FILIALE_PAGE = "filiale-page"
}
